(function() {
    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'HEADER', name: 'KRP0001', isFirstLoad: true, fn: function () {
                if(!document.querySelector('.KRP0001')) return false;
                $('header').vcHeader();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0001')) return false;

        vcui.require(['common/header'], function () {
            $('header').vcHeader();
        });
    });
})();

